import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import LottieSticker from "../LottieSticker";
import { TokenBase, TokenMarket } from "~/types";
import { useAppDispatch } from "~/store";
import { updateToken } from "~/store/token";
import { useNavigate } from "react-router";
import { isValidToken } from "~/pages/Trade/utils";

type TokenShare2EarnBtnProps = {
    className?: string;
    token: {
        token_base: TokenBase;
        token_market: TokenMarket;
    };
};

const TokenShare2EarnBtn: React.FC<TokenShare2EarnBtnProps> = ({
    className,
    token,
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const showShareModal = () => {
        if (isValidToken(token?.token_base)) {
            dispatch(updateToken(token));
            navigate("/token-share");
        }
    };

    return (
        <div
            className={clsx(
                "rounded-[8px] flex items-center bg-AlphaOrange dark:bg-DarkAlphaOrange cursor-pointer",
                className
            )}
            style={{ height: 36, padding: "4px 7px" }}
            onClick={showShareModal}
        >
            <LottieSticker lottieName="hand-coin-orange" className="w-5 h-5" />
            <span
                className="text-body4 font-Semibold text-brand_1 ml-[4px] h-[20px]"
                style={{
                    fontSize: "0.8125rem",
                    lineHeight: "22px",
                }}
            >
                {t("share_2_earn")}
            </span>
        </div>
    );
};

export default TokenShare2EarnBtn;
